import { render, staticRenderFns } from "./stepTwo.vue?vue&type=template&id=04bc5196&scoped=true&"
import script from "./stepTwo.vue?vue&type=script&lang=js&"
export * from "./stepTwo.vue?vue&type=script&lang=js&"
import style0 from "./stepTwo.vue?vue&type=style&index=0&id=04bc5196&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc5196",
  null
  
)

export default component.exports